module.exports = __webpack_public_path__ + "img/code0.3476763c.jpg";